import { tierColor, tierLabel } from "@/lib/tft";

export function TierBadge({ tier, rank, lp, size = "md", className = "" }) {
  const color = tierColor(tier);
  const label = tierLabel(tier, rank);
  const sizeCls = size === "lg" ? "text-sm px-3 py-1.5" : "text-xs px-2.5 py-1";

  return (
    <div
      className={`inline-flex items-center gap-2 rounded-full border font-bold uppercase tracking-wider whitespace-nowrap ${sizeCls} ${className}`}
      style={{
        color,
        borderColor: `${color}55`,
        backgroundColor: `${color}14`,
      }}
      data-testid="tier-badge"
    >
      <span
        className="h-1.5 w-1.5 rounded-full"
        style={{ backgroundColor: color, boxShadow: `0 0 8px ${color}` }}
      />
      <span>{label}</span>
      {lp != null && tier && (
        <span className="text-[#A09B8C]/80 normal-case tracking-normal font-semibold">
          · {lp} LP
        </span>
      )}
    </div>
  );
}
